import React from 'react'

import './badge.scss'



function Badge(props) {
    return (
        <span className={`badge badge-${props.type}`}>
            {props.content}
        </span>
    )
}

export default Badge
